import { FileReader, FileWriter } from '@/platform'

class Var {
    public Name: string = ''
    public Value: number = 0

    constructor(v: number = 0, s: string = '') {
        this.Name = s
        this.Value = v
    }

    readBin(reader: FileReader): void {
        this.Name = reader.readString()
        this.Value = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.Name)
        writer.writeInt(this.Value)
    }

    readVersionedOui(reader: FileReader): void {
        this.Name = reader.readString()
        this.Value = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeString(this.Name)
        writer.writeInt(this.Value)

        writer.writerLength()
    }
}

export default Var
